// extracted by mini-css-extract-plugin
module.exports = {"ordenAtrasada":"TiempoPedido1_ordenAtrasada__GhIlz"};